module.exports = "https://static-production.npmjs.com/5f6e93af5bf0f5dcdd1eecdac99f51ee.png";